<template>
	<div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
		<vx-card>
			<div slot="no-body" style="height: 90px">
				<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
					<span class="cursor-pointer flex items-center i18n-locale">
						<img :src="maptipe_locale_img" :alt="mapTypeSelected" class="responsive card-img-top" />
					</span>
					<vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
						<vs-dropdown-group class="text-center" :vs-label="$t('general.MapTypes')">
							<vs-dropdown-item @click="changeMapType('normal')">
								<div class="drop-items">
									<img
										class="h-8 w-8 img-h"
										:class="[{'map-active': mapTypeSelected === 'normal'}]"
										src="@/assets/images/maps/roadmap.jpg"
										alt="de"
									/>
									<small>{{ $t("MapModule.Default") }}</small>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item @click="changeMapType('satellite')">
								<div class="drop-items">
									<img
										class="h-8 w-8 img-h"
										:class="[
											{
												'map-active': mapTypeSelected === 'satellite',
											},
										]"
										src="@/assets/images/maps/satellite.jpg"
										alt="pt"
									/>
									<small>{{ $t("MapModule.Satellite") }}</small>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item @click="changeMapType('terrain')">
								<div class="drop-items">
									<img
										class="h-8 w-8 img-h"
										:class="[{'map-active': mapTypeSelected === 'terrain'}]"
										src="@/assets/images/maps/terrain.jpg"
										alt="pt"
									/>
									<small>{{ $t("MapModule.Terrain") }}</small>
								</div>
							</vs-dropdown-item>
						</vs-dropdown-group>
						<vs-dropdown-group class="text-center" :vs-label="$t('MapModule.Traffic')">
							<vs-dropdown-item v-if="!activeTrafficLayer" @click="changeMapType('traffic')">
								<div class="drop-items">
									<img
										:class="[{'map-active': activeTrafficLayer}]"
										class="h-8 w-8 img-h"
										src="@/assets/images/maps/traffic.png"
										alt="pt"
									/>
									<small>{{ $t("MapModule.ActivateTraffic") }}</small>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item v-else @click="changeMapType('traffic_clean')">
								<div class="drop-items">
									<img
										:class="[{'map-active': activeTrafficLayer}]"
										class="h-8 w-8 img-h"
										src="@/assets/images/maps/traffic.png"
										alt="pt"
									/>
									<small>{{ $t("MapModule.DisableTraffic") }}</small>
								</div>
							</vs-dropdown-item>
						</vs-dropdown-group>
						<vs-dropdown-group vs-collapse class="text-center" :vs-label="$t('general.Styles')">
							<vs-dropdown-item @click="changeMapStyle('normal.day')"
								>&nbsp; {{ $t("MapModule.Default") }}
							</vs-dropdown-item>
							<vs-dropdown-item @click="changeMapStyle('logistics.night')">&nbsp; Dark </vs-dropdown-item>
							<vs-dropdown-item @click="changeMapStyle('normal.day.grey')">&nbsp; Gray </vs-dropdown-item>
							<vs-dropdown-item @click="changeMapStyle('normal.night.grey')"
								>&nbsp; Dark - Gray
							</vs-dropdown-item>
						</vs-dropdown-group>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<template slot="footer">
				<div class="a-footer" style="background-color: #ff8c34; border-radius: 0px 0px 10px 10px">
					<span class="hidden sm:block">{{ $t("general.MapStyle") }}</span>
				</div>
			</template>
		</vx-card>
	</div>
</template>

<script>
import {setMapStyle, setMapType} from "../../utils/HereMap";

export default {
	data: () => ({
		mapTypeSelected: "normal",
		mapStyleName: "blue_essence",
		card_1: {},
		card_4: {},
	}),
	mounted() {
		if (this.mapTypeSelected === "normal") {
			this.changeMapStyle("normal.day");
		}
	},
	computed: {
		getStyleLoader() {
			return () => import(`./themes/${this.mapStyleName}`);
		},
		maptipe_locale_img() {
			const locale = this.mapTypeSelected;
			if (locale === "satellite") return require("@/assets/images/maps/satellite.jpg");
			else if (locale === "fr") return require("@/assets/images/maps/night_mode.jpg");
			else if (locale === "normal") return require("@/assets/images/maps/roadmap.jpg");
			else if (locale === "terrain") return require("@/assets/images/maps/terrain.jpg");
			else return require("@/assets/images/maps/roadmap.jpg");
		},
		getCurrentLocaleData() {
			const locale = this.$i18n.locale;
			if (locale === "en") return {flag: "us", lang: "English"};
			else if (locale === "es") return {flag: "es", lang: "Spanish"};
		},
		activeTrafficLayer: {
			get() {
				return this.$store.state.moduleMap.activeTrafficLayer;
			},
			set(val) {
				this.$store.dispatch("moduleMap/changeTrafficLayer", val);
			},
		},
	},
	methods: {
		changeMapType(mapType) {
			const isTraffic = mapType === "traffic";
			const isTrafficClean = mapType === "traffic_clean";
			if (!isTraffic && !isTrafficClean) {
				this.mapTypeSelected = mapType;
				if (mapType === "normal") {
					this.changeMapStyle("normal.day");
				}
			}
			this.activeTrafficLayer = isTraffic ? true : isTrafficClean ? false : this.activeTrafficLayer;
			setMapType(mapType, this.activeTrafficLayer);
		},

		changeMapStyle(styleName) {
			setMapStyle(styleName);
		},
	},
};
</script>

<style lang="scss" scoped>
.drop-items {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
}

.img-h {
	transition: width 0.2s, height 0.2s;
}

.map-active {
	border: 1px solid #ababab;
	height: 4rem !important;
	width: 4rem !important;
}

.img-h:hover {
	border: 1px solid #cfcfcf;
	height: 4rem !important;
	width: 4rem !important;
}

.vx-card {
	width: 90px;
	border-radius: 10px;
	background: #000000;
	opacity: 0.9;
	position: fixed;
	top: 59%;
	right: 1%;
	z-index: 50000;
	clear: both;
}

.con-vs-dropdown--menu {
	z-index: 51000;
}
</style>
